import * as React from 'react';
import { formatDateTime } from "../../misc/components/Formatters/Formatters";
import { SvcAnalysisSet, SvcSession, Site, Study } from 'webportalclient';
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from '../../misc/api/ApiPermissionEnum';
import { OverreadStatusEnum, OverreadStatusIdEnum } from '../../misc/api/apiTypes';
import { Subject, Visit } from 'webportalclient';
import { useReferenceContextProvider } from '../../Core/ReferenceContextProvider';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';

export interface SessionMetadataTableProps {
    sessionMetadata: SvcSessionMetadata;
}

export interface SvcSessionMetadata {
    session: SvcSession;
    analysisSet: SvcAnalysisSet;
    site: Site;
    study: Study;
    subject: Subject;
    visit: Visit;
}

const FormatOverreadStatus = (value: string): string => {
    if (value == OverreadStatusIdEnum.NotStarted) {
        return "Not Started";
    }
    if (value == OverreadStatusIdEnum.Accepted) {
        return "Accepted";
    }
    if (value == OverreadStatusIdEnum.Pending) {
        return "Pending";
    }
    if (value == OverreadStatusIdEnum.Rejected) {
        return "Rejected";
    }
    return '-';
};

const HyphonateEmptyString = (value: string): string => {
    if (!value) {
        return "-";
    }

    return value;
}

export const SvcSessionMetadataTable = ({ sessionMetadata }: SessionMetadataTableProps) => {

    const { currentUserPermissions } = useSecurityContext();
    const { countries } = useReferenceContextProvider();
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();
    const ViewOverreaderName = () => {

        return currentUserPermissions.some(x => (x.Id === PermissionEnum.ViewOverreaderName));

    }
    return (
        <div className="panel panel-default">
            <div className="panel-body table-scroll">
                <table className="table">
                    <thead>
                        <tr>
                            <th data-automationid="StudyNameColumn">Study Name</th>
                            <th data-automationid="ProtocolNumberColumn">Protocol Number</th>
                            <th data-automationid="SiteNumberColumn">Site Number</th>
                            <th data-automationid="SiteNameColumn">Site Name</th>
                            <th data-automationid="SiteLocationColumn">Site Location</th>
                            <th data-automationid="TechnicianColumn">Technician</th>
                            <th data-automationid="SubjecTNumberColumn">{fieldDisplayText.SubjectId}</th>
                            <th data-automationid="VisitNameColumn">Visit Name</th>
                            <th data-automationid="SessionNameColumn">Session Name</th>
                            <th data-automationid="SessionStartColumn">Session Start</th>
                            <th data-automationid="StatusColumn">Status</th>
                            {ViewOverreaderName() ? <th data-automationid="OverreaderColumn">Overreader</th> : null}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td data-automationid="StudyNameDetail">{sessionMetadata.study.name}</td>
                            <td data-automationid="ProtocolNumberDetail">{sessionMetadata.study.protocol}</td>
                            <td data-automationid="SiteNumberDetail">{sessionMetadata.site.number}</td>
                            <td data-automationid="SiteNameDetail">{sessionMetadata.site.name}</td>
                            <td data-automationid="SiteLocationDetail">{sessionMetadata.site.country}</td>
                            <td data-automationid="TechnicianDetail">{sessionMetadata.session.technician}</td>
                            <td data-automationid="SubjectNumberDetail">{sessionMetadata.subject.number}</td>
                            <td data-automationid="VisitNameDetail">{sessionMetadata.visit.name}</td>
                            <td data-automationid="SessionNameDetail">{sessionMetadata.session.name}</td>
                            <td data-automationid="SessionStartDetail">{formatDateTime(sessionMetadata.session.occurred)}</td>
                            <td data-automationid="StatusDetail">{FormatOverreadStatus(sessionMetadata.analysisSet.status)}</td>
                            {ViewOverreaderName() ? <td data-automationid="OverreaderDetail">{HyphonateEmptyString(sessionMetadata.analysisSet.analystUserName)}</td> : null}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}


export default SvcSessionMetadataTable;
